import { handleActions, createActions } from 'redux-actions';
import { Map } from 'immutable';
import _ from 'lodash';
import Cookies from 'js-cookie';

import { getLastMsgContent, initVisitor } from '@laigu/utils';

export const initConvVisitInfo = convs => {
  return convs.map(val => ({
    ...val,
    visit_info: initVisitor(val.visit_info)
  }));
};

const createAction = list =>
  list.reduce(
    (prev, now) => ({
      ...prev,
      [now]: result => result
    }),
    {}
  );

export const {
  setMeConversations,
  setColleaguesConversations,
  setAllConversations,
  // 强制添加一些对话进去
  forcePushMeConversations,
  forcePushColleaguesConversations,
  setAtMeConversations,
  setHasGotMeConv,
  setHasGotCollConv,
  setHasGotAtMeConv,
  setHasGotAllConv,
  setUnrecognizedConv,
  setHasGotUnrecognizedConv,
  clearConversations,
  addConvs,
  removeConv,
  updateConvMessage,
  updateConvVisitorName,
  updateConvAgent,
  addClientTagSocket,
  removeClientTagSocket,
  visitorCome,
  visitorOffline,
  updateConvVisitInfo,
  moveConversationFromColleagueToTrusteeship,
  moveConversationFromTrusteeshipToMine,
  setAdvertise,
  setAllTalksParams
  // setConvCustomerLanguage
} = createActions({
  ...createAction([
    'setMeConversations',
    'forcePushMeConversations',
    'forcePushColleaguesConversations',
    'setColleaguesConversations',
    'setAllConversations',
    'setAtMeConversations',
    'setHasGotMeConv',
    'setHasGotUnrecognizedConv',
    'setUnrecognizedConv',
    'setHasGotCollConv',
    'setHasGotAtMeConv',
    'setHasGotAllConv',
    'clearConversations',
    'addConvs',
    'removeConv',
    'updateConvMessage',
    'updateConvVisitorName',
    'updateConvAgent',
    'addClientTagSocket',
    'removeClientTagSocket',
    'visitorCome',
    'visitorOffline',
    'updateConvVisitInfo',
    'moveConversationFromColleagueToTrusteeship',
    'moveConversationFromTrusteeshipToMine',
    'setAdvertise',
    'setAllTalksParams'
    // 设置对话客户使用的语种
    // 'setConvCustomerLanguage'
  ])
});

const initState = Map({
  conv: [],
  colleaguesHasnext: false,
  allConvsHasNext: false,
  nextCursor: -1,
  hasGotMeConv: false,
  hasGotCollConv: false,
  hasGotAtMeConv: false,
  hasGotAllConv: false,
  setHasGotUnrecognizedConv: false,
  advertise: {},
  allStatusTalks: []
});

const filterNewConv = list =>
  list.reduce((convs, newConv) => {
    const index = convs.findIndex(val => val.track_id === newConv.track_id);
    if (index >= 0) {
      const oldConv = convs[index];
      if (newConv.last_updated >= convs[index].last_updated) {
        convs[index] = { ...oldConv, ...newConv };
      } else {
        convs[index] = { ...newConv, ...oldConv };
      }
    } else {
      convs.push(newConv);
    }
    return convs;
  }, []);

function filterOldList(list = [], type) {
  const meId = Cookies.get('_agent_id');
  if (!list?.length) return list;
  switch (type) {
    case 'me':
      return list.filter(c => c.agent_id !== +meId);
    case 'colleagues':
      return list.filter(c => c.agent_id === +meId || window.parseInt(c.mentioned_agent_id) === +meId);
    case '@me':
      return list.filter(c => window.parseInt(c.mentioned_agent_id) !== +meId);
    default:
      return list;
  }
}

function mergeConvs(oldConvs, newConvs) {
  // 如果结束了的对话先排除掉结束了的对话
  const formatNewConvs = newConvs.filter(item => !item.ended_on);
  if (Array.isArray(oldConvs) && Array.isArray(formatNewConvs) && formatNewConvs.length) {
    const formatNewConvList = initConvVisitInfo(formatNewConvs);
    return filterNewConv([...oldConvs, ...formatNewConvList]);
  }
  return oldConvs;
}

function forceMergeConvs(oldConvs, newConvs) {
  if (Array.isArray(oldConvs) && Array.isArray(newConvs) && newConvs.length) {
    const formatNewConvList = initConvVisitInfo(newConvs);
    return filterNewConv([...oldConvs, ...formatNewConvList]);
  }
  return oldConvs;
}

function updateConvByMessage(conv, stream) {
  const { created_on, from_type, type } = stream;
  const extraParam = {};
  if (from_type === 'client') {
    extraParam.client_msg_num = conv ? (conv.client_msg_num || 0) + 1 : 1;
    // 如果是非人头消息，agent_effective_msg_num 数值加1
    if (type === 'message') {
      extraParam.agent_effective_msg_num += 1;
    }
  }
  return { ...conv, last_msg_created_on: created_on, last_msg_content: getLastMsgContent(stream), ...extraParam };
}
// socket推送的stream
function updateConvByMessages(convs, messages) {
  let newMessages = _.sortBy(messages, val => val.created_on);

  // 此处不应该做唯一筛选 会把后续的消息漏掉
  // newMessages = _.unionBy(newMessages, 'track_id');

  return newMessages.reduce((oldConvs, stream) => {
    const { track_id } = stream;
    const conv = convs.find(conv => conv.track_id === track_id);
    const index = convs.findIndex(conv => conv.track_id === track_id);
    const result = oldConvs;
    result[index] = updateConvByMessage(conv, stream);
    return result;
  }, convs);
}

// 更新conv
function updateConv(state, trackId, params) {
  return state.update('conv', convs => {
    return convs.map(conv => {
      let newConv = conv;
      const { track_id } = conv;
      if (track_id === trackId) {
        newConv = { ...newConv, ...params };
      }
      return newConv;
    });
  });
}

function updateConvs(state, list, params) {
  return state.update('conv', convs => {
    return convs.map(conv => {
      let newConv = conv;
      const { track_id } = conv;
      const flag = list.find(val => val.track_id === track_id);
      if (flag) {
        newConv = { ...newConv, ...params };
      }
      return newConv;
    });
  });
}

const conversation = handleActions(
  {
    [setMeConversations]: (state, action) => {
      const oldConv = filterOldList(state.get('conv'), 'me');
      return state.set('conv', mergeConvs(oldConv, action.payload.data));
    },
    [forcePushMeConversations]: (state, action) => {
      return state.set('conv', forceMergeConvs(state.get('conv'), action.payload.data));
    },
    [forcePushColleaguesConversations]: (state, action) => {
      const { data } = action.payload;
      return state.set('conv', forceMergeConvs(state.get('conv'), data));
    },
    [setColleaguesConversations]: (state, action) => {
      const { hasNext, data, nextCursor, reconnect, isTrusteeship } = action.payload;
      const oldConv = !reconnect || isTrusteeship ? state.get('conv') : filterOldList(state.get('conv'), 'colleagues');

      // 托管对话只影响列表
      if (isTrusteeship) return state.set('conv', mergeConvs(oldConv, data));

      return state
        .set('conv', mergeConvs(oldConv, data))
        .set('colleaguesHasnext', hasNext)
        .set('nextCursor', nextCursor);
    },
    [setAllConversations]: (state, action) => {
      const { total, users = [], offset_token, coverData } = action.payload;
      let dataList = users;
      const oldConv = coverData ? [] : state.get('allStatusTalks');
      if (!Array.isArray(dataList)) {
        dataList = [];
      }
      return state
        .set('allStatusTalks', [...oldConv, ...dataList])
        .set('allTalksOffsetToken', offset_token)
        .set('allTalksTotal', total);
    },
    [setAllTalksParams]: (state, action) => {
      const params = action.payload;
      return state.set('allTalksParams', params);
    },
    [setAtMeConversations]: (state, action) => {
      const oldConv = filterOldList(state.get('conv'), '@me');
      return state.set('conv', mergeConvs(oldConv, action.payload.data));
    },
    [setHasGotMeConv]: (state, action) => {
      return state.set('hasGotMeConv', action.payload);
    },
    [setHasGotCollConv]: (state, action) => {
      return state.set('hasGotCollConv', action.payload);
    },
    [setHasGotAtMeConv]: (state, action) => {
      return state.set('hasGotAtMeConv', action.payload);
    },
    [setHasGotAllConv]: (state, action) => {
      return state.set('hasGotAllConv', action.payload);
    },
    [setHasGotUnrecognizedConv]: (state, action) => {
      return state.set('hasGotUnrecognizedConv', action.payload);
    },
    [clearConversations]: state => {
      return state.set('conv', []);
    },
    [addConvs]: (state, action) => {
      return state.set('conv', mergeConvs(state.get('conv'), action.payload));
    },
    [removeConv]: (state, action) => {
      return state.update('conv', convs => {
        if (convs.length && action.payload) {
          return convs.filter(conv => {
            const { track_id } = conv;
            return track_id !== action.payload;
          });
        }
        return convs;
      });
    },
    [updateConvMessage]: (state, action) => {
      const convs = _.clone(state.get('conv'));
      const newConvs = updateConvByMessages(convs, action.payload);
      return state.set('conv', newConvs);
    },
    // 转接事件专用：会话归属是确定性结论，不参与 mergeConvs 的 last_updated 时间竞争，
    // 直接按 track_id 强制覆盖归属字段，避免被列表中的旧数据盖回去
    [updateConvAgent]: (state, action) => {
      const { trackId, ...params } = action.payload || {};
      if (!trackId) return state;
      const validParams = _.omitBy(params, _.isUndefined);
      if (_.isEmpty(validParams)) return state;
      return updateConv(state, trackId, validParams);
    },
    [updateConvVisitorName]: (state, action) => {
      const { trackId, visitorName } = action.payload;
      return state.update('conv', convs => {
        return convs.map(conv => {
          let newConv = conv;
          const { track_id, visit_info } = conv;
          if (track_id === trackId) {
            newConv = { ...newConv, ...{ visit_info: { ...visit_info, ...{ name: visitorName } } } };
          }
          return newConv;
        });
      });
    },
    [addClientTagSocket]: (state, action) => {
      const { track_id, tag_id } = action.payload;
      const conv = state.get('conv').find(conv => conv.track_id === track_id);
      const newTags = (conv && conv.tags) || [];
      return updateConv(state, track_id, { tags: [...newTags, tag_id] });
    },
    [removeClientTagSocket]: (state, action) => {
      const { track_id, tag_id } = action.payload;
      const conv = state.get('conv').find(conv => conv.track_id === track_id);
      const newTags = (conv && conv.tags) || [];
      return updateConv(state, track_id, { tags: newTags.filter(val => val !== tag_id) });
    },
    [visitorCome]: (state, action) => {
      return updateConvs(state, action.payload, { is_client_online: true });
    },
    [visitorOffline]: (state, action) => {
      return updateConvs(state, action.payload, { is_client_online: false });
    },
    [updateConvVisitInfo]: (state, action) => {
      const { track_id, visit_info: actionVisitInfo = {} } = action.payload;
      const conv = state.get('conv').find(val => val.track_id === track_id);
      if (conv && conv.visit_info) {
        const updateData = { ...conv.visit_info, ...actionVisitInfo };
        return updateConv(state, track_id, { visit_info: updateData });
      }
      return state;
    },
    [moveConversationFromColleagueToTrusteeship]: (state, action) => {
      // 把会话从同事移到未识别（托管），一个对话是不是托管对话完全由trusted字段
      // 决定，然后列表视图不在这个store里面
      return state.update('conv', convs => {
        const targetIndex = convs.findIndex(c => c.id === action.payload.conv_id);
        if (targetIndex > -1) {
          // trusted: 0 | 1, 0是普通对话，1是托管对话
          const newConv = { ...convs[targetIndex], trusted: 1 };
          convs.splice(targetIndex, 1, newConv);
          return [...convs];
        }
        return convs;
      });
    },
    [moveConversationFromTrusteeshipToMine]: (state, action) => {
      return state.update('conv', convs => {
        const targetIndex = convs.findIndex(c => c.id === action.payload.conv_id);
        if (targetIndex > -1) {
          // trusted: 0 | 1 | 2, 0是普通对话，1是托管对话, 2预托管对话
          const newConv = { ...convs[targetIndex], trusted: 0 };
          convs.splice(targetIndex, 1, newConv);
          return [...convs];
        }
        return convs;
      });
    },
    [setAdvertise]: (state, action) => {
      return state.set('advertise', action.payload || {});
    }
    // [setConvCustomerLanguage]: (state, action) => {
    //   const {id, language} = action;
    //   const convs = state.get('conv');
    //   const targetIndex = convs.findIndex(c => c.id === id);
    //   if(targetIndex > -1) {
    //     const [target] = convs.splice(targetIndex, 1);
    //     target.customerLanguage = language;
    //     convs.push({...target})
    //     return state.set('conv', convs)
    //   }
    //   return state
    // }
  },
  initState
);

export default conversation;
